import React from 'react'
import { trimValues } from 'lib/helpers/forms'
import { NO_NONE_NOPES, NO_NONE_NOPE_FIELD_DATA } from '../camperConstants'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      updateCamper, // via withMutation
      form: reduxForm, // via withRedux
      camper, // via withQuery
      setCamperFormField // via redux actions
    } = props

    const form = trimValues(reduxForm)

    // perform GraphQL mutation
    const handleClickSubmit = e => {
      e.preventDefault()

      const buildAllergyInput = camperAllergy => {
        const { id, name, severe, food, custom } = camperAllergy
        return { id, name, severe, food, custom }
      }

      form.camperAllergies.forEach(allergy => {
        if (NO_NONE_NOPES.includes(allergy.name)) {
          allergy.name = ''
        }
      })

      form.camperAllergies = form.camperAllergies.filter(allergy => 
        (allergy.name !== '' || allergy.id)
      )

      Object.keys(NO_NONE_NOPE_FIELD_DATA).forEach(fieldData => {
        if (NO_NONE_NOPES.includes(form[fieldData]) || (form[fieldData] && form[fieldData].trim()) === '') {
          form[fieldData] = null
        }
      })

      updateCamper({
        variables: {
          camperId: camper.id,
          input: {
            // personal info
            firstName: form.firstName,
            lastName: form.lastName,
            gender: form.gender,
            birthdate: form.birthdate,
            school: form.school,
            parentNotes: form.parentNotes,
            // allergies and diet
            camperAllergies: form.camperAllergies.map(buildAllergyInput),
            hasDietaryRestrictions: form.hasDietaryRestrictions,
            hasFoodAllergies: form.hasFoodAllergies,
            hasNonFoodAllergies: form.hasNonFoodAllergies,
            foodAllergyNotes: form.foodAllergyNotes,
            nonFoodAllergyNotes: form.nonFoodAllergyNotes,
            dietaryRestrictions: form.dietaryRestrictions,
            dietaryRestrictionsOther: form.dietaryRestrictionsOther,
            sitsSeparately: form.sitsSeparately,
            // medical
            medications: form.medications,
            medicalConditions: form.medicalConditions,
            immunizations: form.immunizations,
            tetanusShotDate: form.tetanusShotDate,
            doctorName: form.doctorName,
            doctorPhoneNumber: form.doctorPhoneNumber
          }
        }
      })
    }

    const updateArrayField = (field, box, checked) => {
      if (checked) {
        if (!form[field].includes(box)) {
          setCamperFormField(field, [...form[field], box])
        }
      } else {
        setCamperFormField(
          field,
          form[field].filter(item => item !== box)
        )
      }
    }

    return (
      <WrappedComponent
        onClickSubmit={handleClickSubmit}
        updateArrayField={updateArrayField}
        {...props}
      />
    )
  }
}

export default withEventHandlers
